import { render, staticRenderFns } from "./LmAgencies.vue?vue&type=template&id=4df481f1"
import script from "./LmAgencies.vue?vue&type=script&lang=js"
export * from "./LmAgencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports